// extracted by mini-css-extract-plugin
export default {"container":"DataTransfer_container__NJOvH","body":"DataTransfer_body__pa4Oj"};